import styled from "styled-components";

const COMPARE_BG =
  "https://tripmoneycmsimgak.mmtcdn.com/img/Compare_bg_curve_a629fb38e6.png";

export const Wrapper = styled.div`
  padding: 0 16px;
`;

export const Card = styled.div<{ $borderColor?: string; $badgePad: boolean }>`
  position: relative;
  background: #fff;
  border-radius: 16px;
  padding-top: ${(p) => (p.$badgePad ? 0 : 12)}px;
  padding-bottom: 12px;
  overflow: hidden;
  border: ${(p) => (p.$borderColor ? `1px solid ${p.$borderColor}` : "none")};
  box-shadow: none;
`;

export const Badge = styled.div<{ $gradient: string }>`
  display: inline-block;
  padding: 2px 10px 2px 10px;
  margin-bottom: 8px;
  border-top-left-radius: 15px;
  border-bottom-right-radius: 16px;
  background: ${(p) => p.$gradient};
`;

export const BadgeText = styled.span<{ $color?: string }>`
  color: ${(p) => p.$color || "#fff"};
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.02em;
`;

export const CardInner = styled.div`
  display: block;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font: inherit;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 16px;
  gap: 8px;
`;

export const TitleCol = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  padding: 5px 0;
`;

export const VendorLogo = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const PlanIconImg = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  object-fit: contain;
  background: #fff;
  flex-shrink: 0;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 900;
  color: #4a4a4a;
  line-height: 1.2;
  word-break: break-word;
`;

export const VendorName = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #757575;
  line-height: normal;
`;

export const PriceCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  gap: 4px;
`;

export const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const OriginalPrice = styled.span`
  font-size: 12px;
  color: #757575;
  text-decoration: line-through;
`;

export const CurrentPrice = styled.span`
  font-size: 18px;
  font-weight: 900;
  color: #000;
`;

export const Unit = styled.span`
  font-size: 12px;
  color: #757575;
`;

export const PersuasionTag = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 6px;
  border-radius: 100px;
  background: linear-gradient(90deg, #bff9e1 0%, #ffffff 100%);
  gap: 4px;
`;

export const PersuasionIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const PersuasionText = styled.span`
  font-size: 12px;
  font-weight: 900;
  color: #2b825e;
  white-space: nowrap;
`;

export const Divider = styled.div`
  height: 1px;
  background: #d8d8d8;
  margin: 0;
`;

export const Benefits = styled.div`
  padding: 8px 16px 0;
`;

export const BenefitRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 12px;
  gap: 8px;
`;

export const BenefitIcon = styled.img`
  width: 12px;
  height: 12px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const BenefitTitle = styled.span`
  flex: 1;
  font-size: 12px;
  font-weight: 400;
  color: #4a4a4a;
`;

export const BenefitCover = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #4a4a4a;
`;

export const ActionsRow = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;

export const DownloadBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font: inherit;
  color: #757575;
`;

export const DownloadLabel = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #4a4a4a;
`;

export const CardCurve = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 154px;
  height: 36px;
  background-image: url(${COMPARE_BG});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  pointer-events: none;
  z-index: 0;
`;

export const CompareBtn = styled.button`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 12px;
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
`;

export const Checkbox = styled.span<{ $on?: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1.5px solid ${(p) => (p.$on ? "#4a90d9" : "#c0c0c0")};
  margin-right: 8px;
  background: ${(p) => (p.$on ? "#4a90d9" : "#fff")};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  font-size: 12px;
  font-weight: 900;
`;

export const CompareLabel = styled.span`
  font-size: 12px;
  color: #000;
`;

export const CtaLinksCol = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px;
`;

export const BenefitsLink = styled.button`
  font-size: 12px;
  font-weight: 700;
  color: #008cff;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  text-align: right;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  background: rgba(252, 237, 212, 0.42);
  padding: 8px 16px;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  width: 95%;
  margin: 0 auto 0;
`;

export const FooterIcon = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

export const FooterText = styled.div`
  flex: 1;
  font-size: 12px;
  color: #000;
`;
